import { Component, OnDestroy, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Request, AuthenticationByApplication, GetUserInfo, AddUserKeys, UpdateUserNick, Ping} from './request';
import { Response, StatusMessage, UserInfo } from './response';
import { Encryption } from './encryption';
import { User } from './model';
import { MessangerConnectionService } from './messanger-connection.service';
import { Router } from '@angular/router';
import {VerificationComponent} from "./verification.component";
import {EulaComponent} from "./eula.component";
import {MatDialog} from "@angular/material/dialog";




@Component({
  selector: 'app-registration-user',
  templateUrl: './registration-user.component.html',
  styleUrls: ['./registration-user.component.css']
})
export class RegistrationUserComponent implements OnInit, OnDestroy {

  userRegistration: FormGroup;
  password = new FormControl('', [Validators.required, Validators.minLength(8)]);
  passwordR = new FormControl('', [Validators.required, Validators.minLength(8)]);
  nick = new FormControl('', [Validators.required, Validators.minLength(3)]);
  email = new FormControl('', [Validators.email, Validators.maxLength(254)]);
  showProgress = false;
  showEmailVerification = false;
  pendingEmail = '';
  registrationError = '';
  hide: boolean = true;
  eula = new FormControl(false);

  okReloadAndBack = false;

  constructor(private router: Router, public con: MessangerConnectionService, public dialog: MatDialog, fb: FormBuilder) {
    let that = this
    window.addEventListener("beforeunload", function (e) {
      if (that.okReloadAndBack) {
        return undefined;
      }
      var confirmationMessage = 'If you leave before saving, your changes will be lost.';

      (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
    });

    this.userRegistration = fb.group({
      passwordR: this.passwordR,
      password: this.password,
      nick: this.nick,
      email: this.email,
    });

    setTimeout(()=> {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 1000)
  }

  registration() {

    let ping = new Ping(new Date());
    this.con.sendRequest(ping, (status) => {
      this.showProgress = true;
      setTimeout(() => {
        this.registrationImpl();
      }, 3000);
    });
  }
  registrationImpl() {
    let encryption = new Encryption(this.con);
    let user: User = encryption.generateUserKeys(this.con.userId, this.nick.value, this.password.value);
    const encryptedEmptyNick = encryption.encryptByMetaDataKey("");
    if (encryptedEmptyNick === null) {
      this.showProgress = false;
      return;
    }

    const recoveryEmail = this.con.registrationRecoveryEmailVerified ? '' : (this.email.value || '').trim();
    let requestAddUserKeys = new AddUserKeys(user.publicKeyBase64, user.privateKeyEncryptedBase64,
      user.metaDataKeyEncryptedBase64, encryptedEmptyNick, recoveryEmail);
    this.con.sendRequest(requestAddUserKeys,
      (responseAddUserKeys) => {
        const addKeysStatus = responseAddUserKeys as StatusMessage;
        if (addKeysStatus.status !== 'ok') {
          this.showProgress = false;
          this.registrationError = addKeysStatus.description || 'Could not create the account. Please try again.';
          return;
        }

        this.con.encryption = encryption;
        this.con.user = user;
        let updateNick = new UpdateUserNick(this.con.encryption.encryptByMetaDataKey(this.nick.value));
        this.con.sendRequest(updateNick, (statusObject) => {
          const updateStatus = statusObject as StatusMessage;
          if (updateStatus.status !== 'ok') {
            this.showProgress = false;
            this.registrationError = updateStatus.description || 'The account was created, but its profile could not be saved.';
            return;
          }

          this.con.nickOpen = this.nick.value;
          if (recoveryEmail) {
            this.pendingEmail = recoveryEmail;
            this.email.setValue('');
            this.showProgress = false;
            this.showEmailVerification = true;
          } else {
            this.finishRegistration();
          }
        });
      });


  }

  emailVerified() {
    this.pendingEmail = '';
    this.showEmailVerification = false;
    this.finishRegistration();
  }

  emailLater() {
    this.pendingEmail = '';
    this.showEmailVerification = false;
    this.finishRegistration();
  }

  private finishRegistration() {
    this.email.setValue('');
    this.pendingEmail = '';
    this.con.registrationRecoveryEmailVerified = false;
    this.router.navigate(['/messenger']);
    this.okReloadAndBack = true;
  }

  ngOnInit() {
    if (this.con.appUuid == null) {
      this.router.navigate(['/']);
    } else {
      this.con.authorizeApp(() => { }, () => {
        this.router.navigate(['/']);
      });

    }
  }

  ngOnDestroy() {
    this.email.setValue('');
    this.pendingEmail = '';
  }

  registrationKeys(event: any) {
    if (event.keyCode == 13) {
      if(this.nick.valid && this.password.valid && this.email.valid && (this.password.value == this.passwordR.value)) {
        this.registration();
      }
    }
  }

  back() {
    this.email.setValue('');
    this.pendingEmail = '';
    this.con.clear();
    window.location.href = "/";
  }

  eulaShow() {
    const eulaComponent = this.dialog.open(EulaComponent, {
      width: '600px',

    });


  }
}
